import { useEffect, useRef } from "react";
import { usePushSubscription } from "@/hooks/usePushSubscription";
import { useAuth } from "@/hooks/useAuth";

export function PushManager() {
	const { supported, permission, subscribe, unsubscribe } = usePushSubscription();
	const { isSignedIn } = useAuth();
	const subscribeRef = useRef(subscribe);
	useEffect(() => {
		subscribeRef.current = subscribe;
	}, [subscribe]);

	const prevSignedIn = useRef(isSignedIn);
	useEffect(() => {
		if (prevSignedIn.current && !isSignedIn) {
			unsubscribe();
		}
		prevSignedIn.current = isSignedIn;
	}, [isSignedIn, unsubscribe]);

	useEffect(() => {
		if (!supported || permission !== "granted") return;
		if (!isSignedIn) return;
		if (!("serviceWorker" in navigator)) return;

		let cancelled = false;

		navigator.serviceWorker
			.register("/sw.js")
			.then((reg) => {
				if (cancelled) return;
				return reg.pushManager.getSubscription();
			})
			.then((sub) => {
				if (cancelled || sub) return;
				return subscribeRef.current();
			})
			.catch((err) => {
				console.error("Push setup failed:", err);
			});

		return () => {
			cancelled = true;
		};
	}, [supported, permission, isSignedIn]);

	return null;
}
